module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/wow-slider/wow-slide-in-up/wow-slide-in-up.component.scss
// module id = ./src/app/features/wow-slider/wow-slide-in-up/wow-slide-in-up.component.scss
// module chunks = main